import type { AxiosError } from 'axios';
import type {
	OsobyPodnikatelSeznamDto,
	PoQueryConfig,
	ResponseError,
} from '@gov-nx/api';
import {
	rosBusinessPersonQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';

export interface RosBusinessPersonQueryProps {
	onSuccess?: (data: OsobyPodnikatelSeznamDto) => void;
	onError?: (error: AxiosError<ResponseError>) => void;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	retry?: number;
	config?: PoQueryConfig;
}

export const useRosBusinessPersonQuery = (
	props?: RosBusinessPersonQueryProps
) => {
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery(
		{
			queryKey: ['osoby', 'podnikatele'],
			queryFn: () => rosBusinessPersonQuery(axiosInstance),
			onSuccess: props?.onSuccess,
			onError: props?.onError,
			enabled: props?.enabled,
			refetchOnWindowFocus: props?.refetchOnWindowFocus,
			retry: props?.retry,
		},
		props?.config
	);

	return query;
};
